/* src/app/workshop-defects/pages/workshop-invoicing/workshop-invoicing.component.scss */
.invoicingHint {
  color: #6c757d;
  font-size: 0.85rem;
  margin-bottom: 1rem;
}
.invoicingTable {
  width: 100%;
  border-collapse: collapse;
  background: #fff;
  border-radius: 0.4rem;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}
.invoicingTable th,
.invoicingTable td {
  padding: 0.6rem 0.75rem;
  text-align: left;
  border-bottom: 1px solid #e9ecef;
  font-size: 0.85rem;
}
.invoicingTable th {
  background: #f1f3f5;
  font-weight: 600;
}
/*# sourceMappingURL=workshop-invoicing.component.css.map */
